import { Descriptions, Divider } from "antd";
import { Typography } from "antd";
import { labelStyle } from "../RequestUtil";

const { Title } = Typography;

const HostCancelCertificationRequest = ({ serviceData, requestData }) => {
  const reactiveColumn = {
    xxl: 1,
    xl: 1,
    lg: 1,
    md: 1,
    sm: 1,
    xs: 1,
  };
  return (
    <>
      <Title level={4} style={{ color: "#001529", marginBottom: 0 }}>
      임대차 계약 연장 거절 내용증명
      </Title>
      <Divider style={{ marginTop: 10 }} />
      <div
        style={{
          backgroundColor: "white",
          padding: 15,
          paddingTop: 5,
          marginBottom: 20,
          borderRadius: 5,
        }}
      >
        <Descriptions
          title="임대차 계약 연장 거절 관련 정보"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >

          <Descriptions.Item
            label="임대차 계약 일자"
            labelStyle={labelStyle}
          >
            {serviceData.cancel.contractDate}
          </Descriptions.Item>

          {/* <Descriptions.Item
            label="임대차 계약 주소"
            labelStyle={labelStyle}
          >
            {`${serviceData.cancel.address1} \n ${serviceData.cancel.address1}`}
          </Descriptions.Item> */}

          <Descriptions.Item
            label="임대 시작 일자"
            labelStyle={labelStyle}
          >
            {serviceData.cancel.startDate}
          </Descriptions.Item>

          <Descriptions.Item
            label="임대 종료 일자"
            labelStyle={labelStyle}
          >
            {serviceData.cancel.endDate}
          </Descriptions.Item>
          
          <Descriptions.Item label="보증금" labelStyle={labelStyle}>
            {serviceData.cancel.deposit.toLocaleString()}
          </Descriptions.Item>
          
          <Descriptions.Item label="임대료" labelStyle={labelStyle}>
            {serviceData.cancel.rent.toLocaleString()}
          </Descriptions.Item>

          <Descriptions.Item
            label="임대료 지금일"
            labelStyle={labelStyle}
          >
            {serviceData.cancel.paymentDate}
          </Descriptions.Item>

          {serviceData.cancel.reason ? (
            <Descriptions.Item label="계약을 해지하려는 이유" labelStyle={labelStyle}>
              {serviceData.cancel.reason}
            </Descriptions.Item>
          ) : null}

          {serviceData.cancel.request ? (
            <Descriptions.Item label="세입자에게 요구할 사항" labelStyle={labelStyle}>
              {serviceData.cancel.request}
            </Descriptions.Item>
          ) : null}

        </Descriptions>

        <Descriptions
          title="상세 내용 및 연락처"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >
          <Descriptions.Item label="발신인" labelStyle={labelStyle}>
            {serviceData.user.information.sender}
          </Descriptions.Item>
          {/* <Descriptions.Item label="발신인 주소" labelStyle={labelStyle}>
            {`${serviceData.user.information.senderAddress1} \n ${serviceData.user.information.senderAddress2}`}
          </Descriptions.Item> */}
          <Descriptions.Item label="발신인 전화번호" labelStyle={labelStyle}>
            {serviceData.user.information.senderPhoneNumber}
          </Descriptions.Item>
          <Descriptions.Item label="수신인" labelStyle={labelStyle}>
            {serviceData.user.information.receiver}
          </Descriptions.Item>
          {/* <Descriptions.Item label="수신인 주소" labelStyle={labelStyle}>
            {`${serviceData.user.information.receiverAddress1} \n ${serviceData.user.information.receiverAddress2}`}
          </Descriptions.Item> */}
          <Descriptions.Item label="수신인 전화번호" labelStyle={labelStyle}>
            {serviceData.user.information.receiverPhoneNumber}
          </Descriptions.Item>

          <Descriptions.Item label="상세 내용" labelStyle={labelStyle}>
            {serviceData.description
              ? serviceData.description.split("\n").map((line, idx) => {
                  return (
                    <span key={idx}>
                      {line}
                      <br />
                    </span>
                  );
                })
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="연락처" labelStyle={labelStyle}>
            {serviceData.contact}
          </Descriptions.Item>
          <Descriptions.Item label="프로모션" labelStyle={labelStyle}>
            {serviceData.promotionCode}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default HostCancelCertificationRequest;
